<template>
  <div class="full-screen">
    <div class="sleigh-content">
      <img class="my-logo" src="../assets/santaandsleigh2.svg">
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: "SantaSpinner"
}
</script>
<style scoped>
.full-screen {
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  max-width: none;
  z-index: 9999 !important;
  background: rgba(253, 6, 6, 0.3);
}
.sleigh-content {
  width: 80vw;
  display: flex;
  flex-direction: row;
  align-self: center;
}
.my-logo {
  width: 100%;
  width: -webkit-fill-available;
  width: -moz-available;
  animation: rotation 3s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>